import MoonRingTask from '@/locales/module/MoonRingTask';

/**当前主文件 - 版本号 */
export const version = 0;

/**周任务 - 语言环境 */
export const MoonRingTaskI18n = MoonRingTask;
